import React from 'react';
import { Link } from 'react-router-dom';
import { FiTwitter, FiInstagram, FiYoutube } from 'react-icons/fi';
import logo from '../../assets/images/logo.png';

const WebsiteFooter: React.FC = () => {
  const footerLinks = {
    Company: [
      { label: 'About Us', path: '/about' },
      { label: 'Careers', path: '/careers' },
      { label: 'Contact', path: '/contact' },
    ],
    Support: [
      { label: 'Help Center', path: '/faq' },
      { label: 'How to Play', path: '/how-to-play' },
      { label: 'Support', path: '/support' },
    ],
    Legal: [
      { label: 'Privacy Policy', path: '/privacy-policy' },
      { label: 'Terms & Conditions', path: '/terms' },
    ],
  };

  return (
    <footer className="bg-[#0a0f0d] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={logo} alt="CricClash" className="w-9 h-9 rounded-lg object-cover" />
              <span className="text-xl font-bold text-white">CricClash</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed">
              The ultimate fantasy cricket platform. Build your dream team, compete with millions, and dominate the field.
            </p>
            <div className="flex gap-4 mt-4">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#00FF85] transition-colors">
                <FiTwitter className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#00FF85] transition-colors">
                <FiInstagram className="w-5 h-5" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#00FF85] transition-colors">
                <FiYoutube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold text-sm mb-4">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-gray-500 hover:text-[#00FF85] text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} CricClash. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-gray-600 hover:text-gray-400 text-xs transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="text-gray-600 hover:text-gray-400 text-xs transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
